import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { ToastService } from 'angular-toastify';
import { NgxSpinnerService } from 'ngx-spinner';
import { JIRA_BOARD_PROJECT_Name } from 'src/app/constant/constant';
import { RepositoryService } from 'src/app/service/repository.service';
@Component({
  selector: 'app-costanalysisreport',
  templateUrl: './costanalysisreport.component.html',
  styleUrls: ['./costanalysisreport.component.css']
})
export class CostanalysisreportComponent implements OnInit {

  cloudForm: FormGroup;
  ociCompartmentNames: any = [];
  filteredComponentName: any = [];
  projectName: string = JIRA_BOARD_PROJECT_Name.OCI;
  @Input() tabGroup!: MatTabGroup;
  summary: string;
  constructor(private fb: FormBuilder, private rs: RepositoryService, private _toastService: ToastService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.cloudForm = this.fb.group({
      compartment_Name: ['', [Validators.required]],
      serviceType: ['', [Validators.required]]

    })
    this.loadOCICompartmentNames()
  }

  /**Loads OCI Compartments */
  private loadOCICompartmentNames(): void {
    this.spinner.show()
    this.rs.getOCIAccounts("All", "List").subscribe({
      next: (res) => {
        this.ociCompartmentNames = res['Items'];
        this.filteredComponentName = [...this.ociCompartmentNames];
        this.spinner.hide();
      },
      error: (error) => {
        this._toastService.error(error?.message);
        this.spinner.hide();
      }
    })
  }

  handleFilteredReturn(filteredData: any[]): void {
    this.filteredComponentName = filteredData
  }

  resetform(): void {
    this.cloudForm.reset();
  }

  onSubmit(): void {
    this.spinner.show();
    this.summary = `Generate Cost Analysis Report by Service and Compartment ${this.cloudForm.get('compartment_Name').value}`;

    this.rs.createCloudServiceRequest(this.projectName, this.summary, this.cloudForm.value, sessionStorage.getItem("wwid")
    ).subscribe({
      next: (res) => {
        this._toastService.success(res['message']);
        this.resetform();
        if (this.tabGroup) { this.tabGroup.selectedIndex = 1 };
        this.spinner.hide();

      },
      error: (error) => {
        this._toastService.error(error?.message || "An unexpected error occurred.");
        this.spinner.hide();

      }
    });
  }


}
